const selector = {
  data() {
    return {
      selector: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selector = this.$gsap.utils.selector(this.$el)
    })
  },
}

export { selector }
